import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Country} from '../../../../../../../common/api';
import {FundsSection} from '../../api/entity/private-account.i';
import {ValueByKeyPipe} from '../../../../../core/pipes/value.by.key.pipe';
import {PrivateAccountsService} from '../../api/service/private-accounts.service';
import {IOption} from 'ng-select';
import {Currency} from '../../../../../shared/api/entity/currency';
import {cloneDeep} from 'lodash'
import {isNullOrUndefined} from 'util';
import {FundsInformationModel} from './funds-information.i';
import {BackofficeRangesService} from '../../../../../shared/api/service/backoffice.ranges.service';
import {Range} from '../../../../../../../common/api/range';
import {BackofficeReasonsService} from "../../../../../shared/api/service/backoffice.reasons.service";
import {Reason} from "../../../../../../../common/api/reason";
import {BackofficePurposesService} from "../../../../../shared/api/service/backoffice.purposes.service";
import {Purpose} from "../../../../../../../common/api/purpose";

@Component({
    selector: 'tfl-private-profile-detail-funds-information',
    template: require('./funds.information.template.html'),
    providers: [ValueByKeyPipe]
})
export class FundsInformationComponent implements OnInit, OnChanges {

    @Input('loading') loading = true;
    @Input('countries') countries: Country[] = [];
    @Input('profileId') profileId: number;
    @Input('currencies') currencies: Currency[] = [];
    @Input('systemOrWL') systemOrWL: string;
    @Input('translatePath') translatePath: string;
    isEdited: boolean = false;
    countryOptions: Array<IOption> = [];
    fundsInformationEdit: FundsInformationModel;
    fundsInformation: FundsSection = null;
    countriesTo: string[] = [];
    countriesFrom: string[] = [];
    averageIncomingTransactionRanges: Array<Range>;
    averageOutgoingTransactionRanges: Array<Range>;
    plannedMonthlyIncomingTurnoverRanges: Array<Range>;
    plannedMonthlyOutgoingTurnoverRanges: Array<Range>;
    plannedMonthlyIncomingTurnoverMoreRanges: Array<Range>;
    plannedMonthlyOutgoingTurnoverMoreRanges: Array<Range>;
    monthlyIncomingFrequencyRanges: Array<Range>;
    monthlyOutgoingFrequencyRanges: Array<Range>;
    averageMonthlyIncomeRanges: Array<Range>;
    fundsSources: Reason[];
    purposes: Purpose[];

    rangeMore: Array<number>;
    private readonly NOT_PROVIDED = 'Not provided';
    private readonly COUNTRY_MALTA_ID = 123;
    private readonly UNIT_EUR = 'EUR';
    private readonly AVERAGE_MONTHLY_INCOME_RANGES_GROUP_ID = 0;
    private readonly AVERAGE_INCOMING_TRANSACTION_RANGES_GROUP_ID = 1;
    private readonly MONTHLY_INCOMING_FREQUENCY_RANGES_GROUP_ID = 3;
    private readonly AVERAGE_OUTGOING_TRANSACTION_RANGES_GROUP_ID = 4;
    private readonly MONTHLY_OUTGOING_FREQUENCY_RANGES_GROUP_ID = 6;
    private readonly PLANNED_MONTHLY_INCOMING_TURNOVER_RANGES_GROUP_ID = 13;
    private readonly PLANNED_MONTHLY_OUTGOING_TURNOVER_RANGES_GROUP_ID = 13;
    private readonly PLANNED_MONTHLY_INCOMING_TURNOVER_RANGES_MORE_GROUP_ID = 14;
    private readonly PLANNED_MONTHLY_OUTGOING_TURNOVER_RANGES_MORE_GROUP_ID = 14;
    private readonly FUNDS_SOURCES_GROUP_ID = 2;

    constructor(private _privateAccountsService: PrivateAccountsService,
                private valueByKeyPipe: ValueByKeyPipe,
                private _rangesService: BackofficeRangesService,
                private _reasonService: BackofficeReasonsService,
                private _purposeService: BackofficePurposesService) {

    }

    @Input('fundsInformation')
    set setApplicantInformation(data: FundsSection) {
        this.fundsInformation = data;
        if (this.fundsInformation) {
            this.fundsInformationEdit = FundsInformationComponent.mapToFundsModeSection(cloneDeep(this.fundsInformation));
        }
    }

    private static mapToFundsModeSection(fundsSection: FundsSection): FundsInformationModel {
        return {
            jurisdiction: fundsSection.initialFunding.jurisdiction,
            accountName: fundsSection.initialFunding.accountName,
            averageMonthlyIncome: fundsSection.initialFunding.averageMonthlyIncome,
            primaryIncomeSource: fundsSection.initialFunding.primaryIncomeSource,
            primaryIncomeSourceOther: fundsSection.initialFunding.primaryIncomeSourceOther,
            countriesTo: fundsSection.transferActivity.countriesTo,
            countriesFrom: fundsSection.transferActivity.countriesFrom,
            purposeOfAccount: fundsSection.transferActivity.purposeOfAccount,
            purposeOfAccountCustom: fundsSection.transferActivity.purposeOfAccountCustom,
            averageIncomingTransferAmount: fundsSection.transferActivity.averageIncomingTransferAmount,
            plannedIncomingTurnoverAmount: fundsSection.transferActivity.plannedIncomingTurnoverAmount,
            monthlyIncomingTransfersCount: fundsSection.transferActivity.monthlyIncomingTransfersCount,
            averageOutgoingTransferAmount: fundsSection.transferActivity.averageOutgoingTransferAmount,
            plannedOutgoingTurnoverAmount: fundsSection.transferActivity.plannedOutgoingTurnoverAmount,
            monthlyOutgoingTransfersCount: fundsSection.transferActivity.monthlyOutgoingTransfersCount
        }
    }

    private static mapToFundsSection(fundsInformationEdit: FundsInformationModel): FundsSection {
        return {
            initialFunding: {
                jurisdiction: fundsInformationEdit.jurisdiction,
                accountName: fundsInformationEdit.accountName,
                averageMonthlyIncome: fundsInformationEdit.averageMonthlyIncome,
                primaryIncomeSource: fundsInformationEdit.primaryIncomeSource,
                primaryIncomeSourceOther: fundsInformationEdit.primaryIncomeSourceOther
            },
            transferActivity: {
                countriesTo: fundsInformationEdit.countriesTo,
                countriesFrom: fundsInformationEdit.countriesFrom,
                purposeOfAccount: fundsInformationEdit.purposeOfAccount,
                purposeOfAccountCustom: fundsInformationEdit.purposeOfAccountCustom,
                averageIncomingTransferAmount: fundsInformationEdit.averageIncomingTransferAmount,
                plannedIncomingTurnoverAmount: fundsInformationEdit.plannedIncomingTurnoverAmount,
                monthlyIncomingTransfersCount: fundsInformationEdit.monthlyIncomingTransfersCount,
                averageOutgoingTransferAmount: fundsInformationEdit.averageOutgoingTransferAmount,
                plannedOutgoingTurnoverAmount: fundsInformationEdit.plannedOutgoingTurnoverAmount,
                monthlyOutgoingTransfersCount: fundsInformationEdit.monthlyOutgoingTransfersCount,
                cryptocurrencies: fundsInformationEdit.cryptocurrencies
            }
        }
    }

    ngOnInit(): void {

        this.rangeMore = [57, 58, 59];

        this._rangesService.getAllRangesByGroupId(this.AVERAGE_INCOMING_TRANSACTION_RANGES_GROUP_ID)
        .subscribe(response => this.averageIncomingTransactionRanges = response);

        this._rangesService.getAllRangesByGroupId(this.PLANNED_MONTHLY_INCOMING_TURNOVER_RANGES_GROUP_ID)
        .subscribe(response => this.plannedMonthlyIncomingTurnoverRanges = response);

        this._rangesService.getAllRangesByGroupId(this.PLANNED_MONTHLY_OUTGOING_TURNOVER_RANGES_GROUP_ID)
        .subscribe(response => this.plannedMonthlyOutgoingTurnoverRanges = response);

        this._rangesService.getAllRangesByGroupId(this.PLANNED_MONTHLY_INCOMING_TURNOVER_RANGES_MORE_GROUP_ID)
        .subscribe(response => this.plannedMonthlyIncomingTurnoverMoreRanges = response);

        this._rangesService.getAllRangesByGroupId(this.PLANNED_MONTHLY_OUTGOING_TURNOVER_RANGES_MORE_GROUP_ID)
        .subscribe(response => this.plannedMonthlyOutgoingTurnoverMoreRanges = response);

        this._rangesService.getAllRangesByGroupId(this.MONTHLY_INCOMING_FREQUENCY_RANGES_GROUP_ID)
        .subscribe(response => this.monthlyIncomingFrequencyRanges = response);

        this._rangesService.getAllRangesByGroupId(this.AVERAGE_OUTGOING_TRANSACTION_RANGES_GROUP_ID)
        .subscribe(response => this.averageOutgoingTransactionRanges = response);

        this._rangesService.getAllRangesByGroupId(this.MONTHLY_OUTGOING_FREQUENCY_RANGES_GROUP_ID)
        .subscribe(response => this.monthlyOutgoingFrequencyRanges = response);

        this._rangesService.getAllRangesByGroupId(this.AVERAGE_MONTHLY_INCOME_RANGES_GROUP_ID)
        .subscribe(response => this.averageMonthlyIncomeRanges = response);

        this._reasonService.getActiveReasonsByGroupId(this.FUNDS_SOURCES_GROUP_ID)
        .subscribe(reasons => this.fundsSources = reasons);
        this._purposeService.getPurposes()
        .subscribe(purposes => this.purposes = purposes);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['countries']) {
            this.countryOptions = this.countries.map(
                country => {
                    return {
                        label: country.name,
                        value: String(country.id)
                    }
                }
            )
        }
    }

    onEdit() {
        this.countriesTo = this.fundsInformation.transferActivity.countriesTo.map(id => id.toString());
        this.countriesFrom = this.fundsInformation.transferActivity.countriesFrom.map(id => id.toString());
        this.fundsInformationEdit = FundsInformationComponent.mapToFundsModeSection(this.fundsInformation);
        this.isEdited = true;
    }

    onDiscard(): void {
        this.isEdited = false;
        this.fundsInformationEdit = FundsInformationComponent.mapToFundsModeSection(this.fundsInformation);
    }

    onSave(): void {
        this.fundsInformationEdit.countriesTo = this.countriesTo.map(id => +id);
        this.fundsInformationEdit.countriesFrom = this.countriesFrom.map(id => +id);

        this.createStubsForApiFields();
        this.fundsInformationEdit.cryptocurrencies = this.fundsInformation.transferActivity.cryptocurrencies;
        this._privateAccountsService.updateFundsInformation(this.profileId, this.fundsInformationEdit)
        .subscribe(response => this.fundsInformation = FundsInformationComponent.mapToFundsSection(cloneDeep(response)));
        this.isEdited = false;
    }

    isValid() {
        return this.countriesTo.length !== 0 && this.countriesFrom.length !== 0;
    }

    templateDict(value: string): string {
        return `${this.translatePath}.${value}`;
    }

    getOutgoingControlName(): string {
        return this.isMoreOutgoingRange() ? 'plannedOutgoingTurnoverAmountMore' : 'plannedOutgoingTurnoverAmount';
    }

    getIdOutgoingPlanned(): string {
        return this.isMoreOutgoingRange() ? 'planned-outgoing-turnover-amount-more' : 'planned-outgoing-turnover-amount';
    }

    getOutgoingRangePlanned(): Array<Range> {
        return this.isMoreOutgoingRange() ? this.plannedMonthlyOutgoingTurnoverMoreRanges : this.plannedMonthlyOutgoingTurnoverRanges;
    }

    getIncomingControlName(): string {
        return this.isMoreIncomingRange() ? 'plannedIncomingTurnoverAmountMore' : 'plannedIncomingTurnoverAmount';
    }

    getIdIncomingPlanned(): string {
        return this.isMoreIncomingRange() ? 'planned-incoming-turnover-amount-more' : 'planned-incoming-turnover-amount';
    }

    getIncomingRangePlanned(): Array<Range> {
        return this.isMoreIncomingRange() ? this.plannedMonthlyIncomingTurnoverMoreRanges : this.plannedMonthlyIncomingTurnoverRanges;
    }

    isPrimaryIncomeSourceOtherRequired(): boolean {
        let fundsSource = this.fundsSources.find(source => source.id === this.fundsInformationEdit.primaryIncomeSource);
        if (isNullOrUndefined(fundsSource)) {
            return false;
        }
        return fundsSource.specify;
    }

    getPrimaryIncomeSource(): string {
        let fundsSource = this.fundsSources.find(source => source.id == this.fundsInformation.initialFunding.primaryIncomeSource);
        if (isNullOrUndefined(fundsSource)) {
            return '';
        }
        return (fundsSource.specify) ? this.fundsInformation.initialFunding.primaryIncomeSourceOther : fundsSource.name;
    }

    onPrimaryIncomeSourceSelect() {
        this.fundsInformationEdit.primaryIncomeSourceOther = null;
    }

    onChangeInputValue(event, fieldName) {
        this.fundsInformationEdit[fieldName] = event.target.value;
    }

    isMoreIncomingRange() {
        return this.rangeMore.indexOf(this.fundsInformationEdit.plannedIncomingTurnoverAmount) !== -1;
    }

    isMoreOutgoingRange() {
        return this.rangeMore.indexOf(this.fundsInformationEdit.plannedOutgoingTurnoverAmount) !== -1;
    }

    private createStubsForApiFields() {
        this.fundsInformationEdit.jurisdiction = this.COUNTRY_MALTA_ID;
        this.fundsInformationEdit.accountName = this.NOT_PROVIDED;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/funds.information/funds.information.component.ts